import { MessageProxy } from "@intelligems/ig-embedded-preview";
import { AppListenerMiddleware } from "@src/store";
import { getEmbeddedMode } from "@src/store/slices/experienceBuilder/common/selectors/getEmbeddedMode";

export const setupSendModeListener = (
  middleware: AppListenerMiddleware,
  messageProxy: MessageProxy
) =>
  middleware.startListening({
    predicate: (_, curr, prev) =>
      getEmbeddedMode(curr) !== getEmbeddedMode(prev),
    effect: (_, { getState }) => {
      messageProxy.send("ig-mode", getEmbeddedMode(getState()));
    },
  });
